// client_serena/src/api/replaceMeal.js
import { getAuth } from "firebase/auth";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const replaceMeal = async (currentMealId, category) => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error("User not logged in");
  const token = await user.getIdToken();

  const res = await fetch(`${API_BASE_URL}/api/user/replace-meal`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ currentMealId, category }),
  });

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || "Failed to replace meal");
  }

  return await res.json();
};
